require('./dashboard.component.scss');

class DashboardController {
  constructor(
    $scope,
    $element,
    $timeout,
    CurrentFilterService,
    FilterResource,
    CurrentFilterDataService,
    PermissionService,
    LayoutService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$timeout = $timeout;
    this.CurrentFilterService = CurrentFilterService;
    this.FilterResource = FilterResource;
    this.permission = PermissionService;
    this.layout = LayoutService;
    this.router = RouterService;
    this.graggingFilter = {};
    this.currentDIndex = 0;
    this.indexes = {};
    this.CurrentFilterDataService = CurrentFilterDataService;
    $scope.$on('$destroy', () => {
      delete this.CurrentFilterDataService.dashboardData;
    });
    $scope.$on('FilterDataLoaded', () => {
      const el = this.$element.closest('.sc-view-container');
      if (el[0]) el.scrollTop(0);
    });

  }

  filterMinimazed(filter) {
    return filter.cardMinimazed;
  }

  get showCard() {
    return !this.filterData.loading && this.filter.filters[0] && !this.filter.isCardAccount;
  }

  getHeightPx(filter, minimized, minHeight = 0) {
    if (!filter.cardWidth) return 0;
    if (minimized) return 28;
    const marginHorz = 0.5; // percent
    const marginVert = 7; // px
    const width = this.$element.width();
    const normalHeight = Math.round(width / 12 * filter.cardHeight - marginVert - 2);
    let cardHeight = filter.cardHeight;
    if (filter && !filter.cardHeight && !minimized) {
      if (filter.isChart || filter.isChartArea ||
        filter.isTree || filter.isGraph) {
        const height = Math.max(Math.round(filter.cardWidth * width * ((1 - 0.01 * marginHorz) / 12) * 0.618), minHeight);
        cardHeight = Math.ceil(height/width * 12);
      } else return 0;
    }
    return Math.round(width / 12 * cardHeight - marginVert - 2);
  }

  get canChange() {
    return this.CurrentFilterService.filter.id === this.filter.id;
  }

  getHeight(filter) {
    const height = this.getHeightPx(filter);
    if (!height) {
      return 'auto';
    }
    return height + 'px';
  }

  placeholderHeight() {
    const height = this.getHeightPx(this.graggingFilter, this.filterMinimazed(this.graggingFilter));
    return height;
  }

  dropCallback(srcList, srcIndex, targetList, targetIndex) {
    // console.log(srcList, srcIndex, targetList, targetIndex);

    this.dropPosition = {
      id: srcList[srcIndex].id,
      // parent_id: this.filter.isCard && this.filter.cardFilter? this.filter.cardFilter.id : this.filter.id,
      parent_id: this.filter.id,
      prev_id: targetIndex - 1 >= 0 ? targetList[targetIndex - 1].id : null
    };
    // Copy the item from source to target.
    targetList.splice(targetIndex, 0, srcList[srcIndex]);
    // Remove the item from the source, possibly correcting the index first.
    // We must do this immediately, otherwise ng-repeat complains about duplicates.
    if (srcList == targetList && targetIndex <= srcIndex) srcIndex++;
    srcList.splice(srcIndex, 1);
    // By returning true from dnd-drop we signalize we already inserted the item.
    return true;
  }

  dragStart(index) {
    // console.log(index);
    this.graggingFilter = this.filter.children[index];
    this.movedIndex = index;
  }

  dragEnd() {
    // console.log(this.CurrentFilterService.filter);
    // if (this.filter.isCard && this.filter.cardFilter) this.filter.cardFilter.children = angular.copy(this.filter.children);
    this.router.filter = this.filter;

  }

  get isEditDasboard() {
    return this.router.isEditDasboard && !this.noEdit;
  }

}

export const DashboardComponent = {
  template: require('./dashboard.component.html'),
  bindings: {
    filter: '<',
    filterData: '<',
    noEdit: '<',
  },
  controller: DashboardController,
};



// WEBPACK FOOTER //
// ./src/view/dashboard/dashboard.component.js